class BrowserCheckService {

    constructor(
        $window
    ) {
        'ngInject';

        this.$window = $window;
    }

    getBrowser() {
        const userAgent = this.$window.navigator.userAgent;

        const browsers = {
            chrome: /chrome/i,
            safari: /safari/i,
            firefox: /firefox/i,
            ie: /internet explorer/i
        };

        for(let key in browsers) {
            if (browsers[key].test(userAgent)) {
                return key;
            }
       }

       return 'unknown';
    }

    isChrome() {
        return this.getBrowser() === 'chrome';
    }
}

export default BrowserCheckService;


// WEBPACK FOOTER //
// ./app/common/browser-check/browser-check-service.js